<script setup lang="ts">
const properties = withDefaults(
  defineProps<{
    fill?: number;
  }>(),
  {
    fill: 1,
  },
);

const fillWidthClass = computed(() => {
  if (properties.fill >= 1) return 'w-full';
  if (properties.fill >= 0.75) return 'w-3/4';
  if (properties.fill >= 0.5) return 'w-1/2';
  if (properties.fill >= 0.25) return 'w-1/4';
  return 'w-0';
});
</script>

<template>
  <span class="star relative block h-4 w-4 bg-gray-100">
    <span
      v-if="properties.fill > 0"
      class="absolute inset-y-0 left-0 bg-orange-400"
      :class="fillWidthClass"
    />
  </span>
</template>

<style scoped>
.star {
  clip-path: polygon(50% 0%, 63% 32%, 98% 35%, 71% 57%, 79% 90%, 50% 72%, 21% 90%, 29% 57%, 2% 35%, 37% 32%);
}
</style>
